import { Checkbox as BaseCheckbox } from "@yandex-int/hr-components/Checkbox";
import { ComponentProps } from "react";
import './checkbox.css';

export interface CheckboxProps extends ComponentProps<typeof BaseCheckbox> {

}
export const Checkbox = (props: CheckboxProps) => {
    return <BaseCheckbox {...props}/>
}
